// Runtime text overrides for on-site inline editing (mirrors pdpMedia).
const OVERRIDES = {};

export function txt(slot, fallback = "") {
  return OVERRIDES[slot] ?? fallback;
}

export function applyTextOverrides(data) {
  Object.assign(OVERRIDES, data || {});
}

export function setTextOverride(slot, value) {
  if (value == null || value === "") delete OVERRIDES[slot];
  else OVERRIDES[slot] = value;
}
